export function mapTextTypeToTagType(textType) {
    const mapping = {
        h1: 'h2',
        h2: 'h2',
        subhead: 'h6',
        paragraph: 'p',
        tag: 'p',
    };
    return mapping[textType];
}
//# sourceMappingURL=utils.js.map